export default function useHeadwayWidget() {
    function injectScript(): void {
        const scriptContent = `
            <script onload="initHeadway()" src="//cdn.headwayapp.co/widget.js"></script>
            <script>
                function initHeadway() {
                    var config = {
                        selector: ".headwayapp-widget",
                        account: "yB4nZ7",
                    }

                    Headway.init(config)
                }
            </script>
        `

        const documentFragment = document
            .createRange()
            .createContextualFragment(scriptContent)

        document.head.appendChild(documentFragment)
    }

    return {
        injectScript,
    }
}
